export default __webpack_public_path__ + "static/media/jp2.e02db42a.jpg";